import React, { Component } from 'react';
import AppBar from '../components/AppBar.jsx';
import Dialog from 'material-ui/Dialog';
import AlertsStore from '../reflux/stores/AlertsStore';
import FlatButton from 'material-ui/FlatButton';
import Loading from '../components/Loading.jsx';
import CircularProgress from 'material-ui/CircularProgress';

const containerStyle = {
    margin: 'auto',
    height: '100%',
    position: 'relative',
    paddingRight: 15,
    paddingLeft: 15
};

export default class Base extends Component {

    constructor(props) {
        
        super(props);
        this.state = {
            alertOpen:false,
            alertMessages:null,
            alertTitle: null,
            authenticated: false,
            drawerMargin: 0,
        };

        this.handleAlerts = this.handleAlerts.bind(this);
    }
      
    componentDidMount() {
        this.unsubscribe = AlertsStore.listen(this.handleAlerts);
    }


    componentWillUnmount() {
        this.unsubscribe();
    }
    
 
    /**
     * Handles all incoming alerts and displays a modal with the messages
     * 
     * @param {string} e The type of alert that is being sent.
     * @param {string} title The title for the modal
     * @param {any} messages the messages to be displayed as children of modal
     * 
     * @return {void}
     */
    handleAlerts(e, title, messages) {
        switch(e) {
            case 'open':
                this.setState({
                    alertTitle: title,
                    alertOpen:true, 
                    alertMessages: messages
                });
                break;
            case 'close':
                this.setState({
                    alertTitle: 'title',
                    alertOpen:false, 
                    alertMessages: null
                });
                break;
            case 'login':
                this.setState({authenticated: true});
                break;
            case 'auth_failed':
                this.setState({authenticated: false});
                this.props.router.push('login');
                break;
            case 'resize':
                let margin = 0;
                if (title.x > 1040) margin = 270;
                    this.setState({drawerMargin: margin});
                break;
        }
    }
    
    render() {
        let messages = this.state.alertMessages;
        return this.state.authenticated
        ?  (
            <div >
                <Dialog
                title={this.state.alertTitle}
                modal={true}
                style={{zIndex:10001}}
                actions={<FlatButton label="Cerrar" onTouchTap={this.handleAlerts.bind(this, 'close')}/>}
                open={this.state.alertOpen}>
                <div >{messages}</div>
                </Dialog>                       
                
                <AppBar router={this.props.router} />

                <Loading />
                <div style={{display: 'flex',marginLeft:this.state.drawerMargin}}>
                    <div style={containerStyle} className="container">
                        {this.props.children}
                    </div>
                </div>

            </div>
        )
        : (
        <div className="retivacontainer center">
            <h4 className="center">Verificando Autenticación...</h4>
             <CircularProgress className="center" size={2} />
        </div>);
    }
}



/** WEBPACK FOOTER **
 ** ./app-react/pages/Base.jsx
 **/